import { Colors } from '../common/Colors';
import { HintProps } from '../desktop/Hint';
import { helperAdjust } from './adjust';

type viewHintListType = {
  [key: string]: {
    color: string;
    backgroundColor: string;
  };
};

export const helperViewHintList: viewHintListType = {
  success: {
    color: Colors.white,
    backgroundColor: Colors.hintSuccess
  },
  warning: {
    color: Colors.brown,
    backgroundColor: Colors.hintWarning
  },
  error: {
    color: Colors.white,
    backgroundColor: Colors.hintError
  },
  danger: {
    color: Colors.white,
    backgroundColor: Colors.hintSell
  },
  info: {
    color: Colors.black,
    backgroundColor: Colors.hintInfo
  },
  alert: {
    color: Colors.red,
    backgroundColor: Colors.hintAlert
  },
  buy: {
    color: Colors.white,
    backgroundColor: Colors.hintBuy
  },
  sell: {
    color: Colors.white,
    backgroundColor: Colors.hintSell
  }
};

export const helperGetShadowColor = (view: HintProps['view']) =>
  helperAdjust(helperViewHintList[view!].backgroundColor, -25);
